export default __webpack_public_path__ + "static/media/facebook.a5509cf9.svg";